import { notifications } from '@mantine/notifications';


export const NotifySuccess = ({
    title,
    message
}) => {
    notifications.show(
        {
        
        title,
        message,
        // icon: <IconCheck />,
        color: 'green',
    })
}
export const NotifyError = ({
    title,
    message
},
) => {
    // const {theme} = useTheme();
    notifications.show({
        title,
        message,
        // icon: <IconX />,
        color: 'red'
    })
    
}
